import styled from 'styled-components/macro'

export const Container = styled.div`
  width: 100%;
  // background-color: #e8ebeb;
  height: fit-content;
  // padding: 12px;
  // position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
`
export const DriversImg = styled.img`
  position: absolute;
  top: 20px;
  right: 12px;
  cursor: pointer;
`
export const DriversTitle = styled.h3`
  // padding-left: 0px;
`
export const DriversContent = styled.li`
  margin-top: 8px;
  margin-bottom: 8px;
`
